<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    bgColor: string
    icon: string
    iconSize?: number
  }>(),
  {
    iconSize: 150,
  }
)

const { smAndDown } = useDisplay()
const { getColorValue } = useColor()

const bgColorValue = computed(() => {
  return getColorValue(props.bgColor)
})
</script>

<template>
  <div class="card">
    <v-icon :size="smAndDown ? 50 : props.iconSize" class="card__icon">{{ icon }}</v-icon>
    <p class="card__description">
      <slot />
    </p>
  </div>
</template>

<style lang="scss" scoped>
.card {
  background-color: v-bind(bgColorValue);
  border-radius: 20px;
  width: 100%;
  padding: 0 11 * $bw 7 * $bw 11 * $bw;
  @include max-width(sm) {
    padding: 0 6 * $bw 4 * $bw 6 * $bw;
  }
  &__icon {
    margin-top: -40px;
    @include max-width(sm) {
      margin-top: -20px;
    }
  }
  &__description {
    font-size: 1.5rem;
    @include max-width(sm) {
      font-size: 1rem;
    }
  }
}
</style>
